import { DAY_PART_SELECTIONS } from 'constants/menu';

import { useCallback } from 'react';

import { useStoreContext } from 'features/store';

import { ISection } from '@rbi-ctg/menu';
import { useMainMenuContext } from 'state/menu/main-menu';
import { IMenuObjectWithDaypart } from 'utils/availability';
import {
  getMenuItemDayParts,
  isAvailableForActiveDayParts,
} from 'utils/availability/daypart-availability';
import { findBurgersForBreakfastDayPart } from 'utils/daypart';

export const useFilterSectionOptionsByDayPart = () => {
  const { activeDayParts, dayParts } = useMainMenuContext();
  const { store } = useStoreContext();
  const hasBurgersForBreakfast = store?.hasBurgersForBreakfast;
  const burgersForBreakfastDayPart = findBurgersForBreakfastDayPart(activeDayParts);

  return useCallback(
    (menuSection: Partial<ISection> | null) => {
      if (!menuSection?.options?.length || !dayParts?.length) {
        return menuSection;
      }

      const isMenuObjectAvailableByDayPart = (
        menuObject: IMenuObjectWithDaypart | null | undefined
      ): boolean => {
        if (!menuObject) {
          return false;
        }

        const menuObjectDayParts = getMenuItemDayParts(menuObject);

        // First checks for burgers for breakfast availability
        if (
          burgersForBreakfastDayPart &&
          menuObjectDayParts.includes(DAY_PART_SELECTIONS.BURGERS_FOR_BREAKFAST.toLowerCase())
        ) {
          return !!hasBurgersForBreakfast;
        }

        // Then checks for the rest of dayparts ['All', 'Main Menu', 'Breakfast']
        const isAvailableForDayParts = isAvailableForActiveDayParts({
          activeDayParts,
          menuData: menuObject,
        });

        if (!isAvailableForDayParts) {
          return false;
        }

        return true;
      };

      const options = menuSection.options.filter(menuObject =>
        isMenuObjectAvailableByDayPart(menuObject as IMenuObjectWithDaypart)
      );

      return {
        ...menuSection,
        options,
      };
    },
    [activeDayParts, burgersForBreakfastDayPart, dayParts?.length, hasBurgersForBreakfast]
  );
};
